import { AJOUTE_RESTAURANT, SUPRIMER_RESTAURANT} from '../types/typeRestaurant';
const restaurant = [];
const RestaurantReducer = (state = restaurant, action) => {
    if (localStorage.getItem('restaurant')) {
        state = JSON.parse(localStorage.getItem('restaurant'));
    }
    switch (action.type) {
        case AJOUTE_RESTAURANT:
            state = action.payload;
            return state;
            break;
        case SUPRIMER_RESTAURANT:
            return state = [];
        default:
            return state;

    }
}

export default RestaurantReducer;